import React, { useState, useEffect, Component, useRef, forwardRef } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGameAssessment";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { debug } from "util";
import { render } from "react-dom";
//import style from './Geo.module.css';
import { Textfit } from 'react-textfit';

import style from '../../components/Geo.module.css';
import { Scale } from 'react-scaling';
//modes
import AsCalculator from "../../components/AsCalculator";
import AsCalculatorFraction from "../../components/AsCalculatorFraction";
import AsCalculatorFractionMixed from "../../components/AsCalculatorFractionMixed";

import axios from "axios";
import useAuth from "../../../auth/hooks/useAuth";

import next from "../../assets/maths_assessments/assets/Next.png";
import back from "../../assets/maths_assessments/assets/Back.png";
import blankbg from "../../assets/maths_assessments/assets/Blank.png";
import marks1 from "../../assets/maths_assessments/assets/marks1.png";

//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;
var image;

//THESE VARIABLES NEED TO BE OUTSIDE THE EXPORT OTHERWISE THEY ARE SET TO DEFAULT EVERY FRAME
var questionNum = 0;
var useranswers = [];
var shuffledAnswers = [];

//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}


export default function SummerAr({ ...props }) {
  const [loading, setLoading] = useState(true);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const { state: authState } = useAuth();
  const [gameOver, setGameOver] = useState(false);

  const [clearCalc, setClear] = useState(false);

  //this.calculator = React.createRef();


  /*
  const { questions, status } = useTopicQuestions({
    topics: props.topics,
    game_type: props.gameType
  });*/
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [extraChars, setExtraChars] = useState([]);
  const [refresh, setRefresh] = useState(false)
  const [displayImage, setDisplayImage] = useState(false);

  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(2);

  const [status, setStatus] = useState(false);

  //0 = keypad, 
  //1 = multiple choice,
  // 2 = fraction,
  // 3 = int & frac

  //questions section
  var questionsY1Summer = [];
  questionsY1Summer.push({ "question" : "How many counters should be in number frame A?", "answer" : "4", "type": 0, "units" : "", "marks" : 1})
questionsY1Summer.push({ "question" : "What number is labelled A on the number line below?", "answer" : "2", "type": 0, "units" : "", "marks" : 1})
questionsY1Summer.push({ "question" : "What number is labelled B on the number line below?", "answer" : "4", "type": 0, "units" : "", "marks" : 1})
questionsY1Summer.push({ "question" : "What number is labelled C on the number line below?", "answer" : "6", "type": 0, "units" : "", "marks" : 1})
questionsY1Summer.push({ "question" : "Aimee makes a number on a bead string. What is one <b>more</b> than Aimee's number?", "answer" : "16", "type": 0, "units" : "", "marks" : 1})
questionsY1Summer.push({ "question" : "Complete the sentence.  17 is one more than _", "answer" : "16", "type": 0, "units" : "", "marks" : 1})
questionsY1Summer.push({ "question" : "Scrambler is organising his shapes. What type of shape is A?", "answer" : "Cylinder|Pyramid|Cube", "type": 1, "units" : "", "marks" : 1})
questionsY1Summer.push({ "question" : "Scrambler is organising his shapes. What type of shape is B?", "answer" : "Cuboid|Cylinder|Sphere", "type": 1, "units" : "", "marks" : 1})
questionsY1Summer.push({ "question" : "Scrambler is organising his shapes. What type of shape is C?", "answer" : "Cube|Sphere|Pyramid", "type": 1, "units" : "", "marks" : 1})
questionsY1Summer.push({ "question" : "What time is shown on clock A? ", "answer" : "half past 3|half past 4|half past 7", "type": 1, "units" : "", "marks" : 1})
questionsY1Summer.push({ "question" : "What time is shown on clock B? ", "answer" : "half past 9|half past 10|half past 11", "type": 1, "units" : "", "marks" : 1})
questionsY1Summer.push({ "question" : "What time is shown on clock C? ", "answer" : "7 o'clock|6 o'clock|9 o'clock", "type": 1, "units" : "", "marks" : 1})
questionsY1Summer.push({ "question" : "Which is the tallest rocket? ", "answer" : "A|B|C", "type": 1, "units" : "", "marks" : 1})
questionsY1Summer.push({ "question" : "_ is shorter than _. ", "answer" : "B is shorter than C|A is shorter than C|A is shorter than B", "type": 1, "units" : "", "marks" : 1})
questionsY1Summer.push({ "question" : "Which ten frame shows the same number? ", "answer" : "C|A|B", "type": 1, "units" : "", "marks" : 1})
questionsY1Summer.push({ "question" : "Emile is facing the rocket. Emile makes a half turn. Which object is he facing now?", "answer" : "key|ball|hat", "type": 1, "units" : "", "marks" : 1})
questionsY1Summer.push({ "question" : "Scrambler has made a number. What number has Scrambler made? ", "answer" : "74", "type": 0, "units" : "", "marks" : 1})
questionsY1Summer.push({ "question" : "Gems come in bags of 5. Aimee finds 8 bags. How many gems does Aimee have altogether? ", "answer" : "40", "type": 0, "units" : "gems", "marks" : 1})
questionsY1Summer.push({ "question" : "Emile has these three coins. He gives the 50p coin to Aimee. Which coin does he give to Aimee?", "answer" : "A|B|C", "type": 1, "units" : "", "marks" : 1})
questionsY1Summer.push({ "question" : "Scrambler is weighing fruit. True or false. The apple is heavier than the banana.", "answer" : "False|True", "type": 4, "units" : "", "marks" : 1})
questionsY1Summer.push({ "question" : "Which is the heaviest fruit? ", "answer" : "Banana|Pear|Apple", "type": 1, "units" : "", "marks" : 1})
questionsY1Summer.push({ "question" : "Here is a shape.", "answer" : "1/4|1/8|1/2", "type": 1, "units" : "", "marks" : 1})
questionsY1Summer.push({ "question" : "There are 15 gems in a box. Scrambler uses some. Scrambler has this many gems left. How many gems did Scrambler use? ", "answer" : "9", "type": 0, "units" : "gems", "marks" : 1})
questionsY1Summer.push({ "question" : "Which numbers are in order? ", "answer" : "67, 68, 69, 70, 71|67, 69, 68, 70, 71|67, 68, 69, 71, 70", "type": 1, "units" : "", "marks" : 1})

  var questionsY2Summer = [];
  questionsY2Summer.push({ "question" : "What number is labelled A on the number line below?", "answer" : "73", "type": 0, "units" : "", "marks" : 1})
  questionsY2Summer.push({ "question" : "What number is labelled B on the number line below?", "answer" : "77", "type": 0, "units" : "", "marks" : 1})
  questionsY2Summer.push({ "question" : "Emile has rotated clockwise. Choose the sentence that is correct.", "answer" : "Emile has made a three-quarter turn clockwise. |Emile has made a quarter turn clockwise. |Emile has made a half turn. ", "type": 1, "units" : "", "marks" : 1})
  questionsY2Summer.push({ "question" : "What number is represented above? ", "answer" : "47", "type": 0, "units" : "", "marks" : 1})
  questionsY2Summer.push({ "question" : "What is the correct way to write 47 in words?", "answer" : "Forty-seven.|Thirty-seven|Forty-three", "type": 1, "units" : "", "marks" : 1})
  questionsY2Summer.push({ "question" : "Is the number 76 odd or even? ", "answer" : "Even|Odd", "type": 4, "units" : "", "marks" : 1})
  questionsY2Summer.push({ "question" : "Select a number that is greater than 37 and less than 71.", "answer" : "42|74|29", "type": 1, "units" : "", "marks" : 1})
  questionsY2Summer.push({ "question" : "Aimee is counting in 2s. She starts at 44. Which numbers will Aimee say?", "answer" : "56, 62|56, 63|56, 65", "type": 1, "units" : "", "marks" : 1})
  questionsY2Summer.push({ "question" : "Scrambler is pouring fuel into beakers. He says \"Beaker C has less fuel than beaker A\". Is Scrambler's statement true or false? ", "answer" : "False|True", "type": 4, "units" : "", "marks" : 1})
  questionsY2Summer.push({ "question" : "Scrambler says \"Beaker B has the least fuel\". Is Scrambler's statement true or false? ", "answer" : "False|True", "type": 4, "units" : "", "marks" : 1})
  questionsY2Summer.push({ "question" : "Scrambler says \"Beaker C is 3/6 full\". Is Scrambler's statement true or false? ", "answer" : "True|False", "type": 4, "units" : "", "marks" : 1})
  questionsY2Summer.push({ "question" : "Emile buys a Roman soldier helmet and a pirate hat. How much does Emile pay?", "answer" : "29", "type": 0, "units" : "£", "marks" : 1})
  questionsY2Summer.push({ "question" : "Aimee has £25. Aimee would like to buy a space helmet. How much <b>more</b> money does she need?", "answer" : "28", "type": 0, "units" : "£", "marks" : 1})
  questionsY2Summer.push({ "question" : "Below is a number sentence. Which numbers can complete the sentence correctly? ", "answer" : "6|10|9", "type": 1, "units" : "", "marks" : 1})
  questionsY2Summer.push({ "question" : "Scrambler is flying from his home planet to Emile's planet. The clocks show when he left and when he arrived. How many minutes did the flight take? ", "answer" : "30", "type": 0, "units" : "minutes", "marks" : 1})
  questionsY2Summer.push({ "question" : "Emile flies his rocket for 3 hours. How many minutes was Emile flying his rocket? ", "answer" : "180", "type": 0, "units" : "minutes", "marks" : 1})
  questionsY2Summer.push({ "question" : "What number should be in place of A? ", "answer" : "10|8|9", "type": 1, "units" : "", "marks" : 1})
  questionsY2Summer.push({ "question" : "What number should be in place of B? ", "answer" : "50|40|55", "type": 1, "units" : "", "marks" : 1})
  questionsY2Summer.push({ "question" : "What number should be in place of C? ", "answer" : "20|22|18", "type": 1, "units" : "", "marks" : 1})
  questionsY2Summer.push({ "question" : "Here is a thermometer. What is the temperature?", "answer" : "35°|25°|30°", "type": 1, "units" : "", "marks" : 1})
  questionsY2Summer.push({ "question" : "What type of shape is shape A?", "answer" : "3-D shape|2-D shape", "type": 4, "units" : "", "marks" : 1})
  questionsY2Summer.push({ "question" : "What type of shape is shape B?", "answer" : "2-D shape|3-D shape", "type": 4, "units" : "", "marks" : 1})
  questionsY2Summer.push({ "question" : "There are 64 different fancy dress outfits in Emile's rocket. Emile leaves 17 outfits at Aimee's house. Scrambler borrows 26 oufits and takes them home. How many outfits are there left in Emile's rocket? ", "answer" : "21 outfits|23 outfits|19 outfits", "type": 1, "units" : "", "marks" : 2})
  questionsY2Summer.push({ "question" : "How much of shape A is shaded? ", "answer" : "1/3|1/2|1/4", "type": 1, "units" : "", "marks" : 1})
  questionsY2Summer.push({ "question" : "How much of shape B is shaded? ", "answer" : "1/4|1/2|1/3", "type": 1, "units" : "", "marks" : 1})
  questionsY2Summer.push({ "question" : "How much of shape C is shaded? ", "answer" : "2/3|1/6|4/5", "type": 1, "units" : "", "marks" : 1})
  

  var questionsY3Summer = [];
  questionsY3Summer.push({ "question" : "What number should be used in place of A to complete the sequence? ", "answer" : "100", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "What number should be used in place of B to complete the sequence? ", "answer" : "200", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "What number should be used in place of C to complete the sequence? ", "answer" : "250", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "What number should be used in place of D to complete the sequence? ", "answer" : "48", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "What number should be used in place of E to complete the sequence? ", "answer" : "40", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "What number should be used in place of F to complete the sequence? ", "answer" : "36", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "Feathers are sold in boxes of 10 and 100. How many feathers are in the boxes below? ", "answer" : "640", "type": 0, "units" : "feathers", "marks" : 1})
questionsY3Summer.push({ "question" : "Which shape has 6 faces and 8 vertices?", "answer" : "B|A|C", "type": 1, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "How many minutes are in an hour? ", "answer" : "60", "type": 0, "units" : "minutes", "marks" : 1})
questionsY3Summer.push({ "question" : "What is the word missing from this sentence. There are 31 _____ in January. ", "answer" : "Days|Hours|Weeks", "type": 1, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "What is the fraction A? ", "answer" : "3/10|2/10|1/10", "type": 1, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "What is the fraction B? ", "answer" : "6/10|5/10|4/10", "type": 1, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "What is the fraction C? ", "answer" : "9/10|8/10|10/10", "type": 1, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "Which line is horizontal?", "answer" : "B|A|C", "type": 1, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "Which lines are perpendicular to one another? ", "answer" : "D|E|F", "type": 1, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "How much fuel is in the beaker? ", "answer" : "550", "type": 0, "units" : "ml", "marks" : 1})
questionsY3Summer.push({ "question" : "Emile uses 225ml of fuel. How much fel is left? ", "answer" : "325", "type": 0, "units" : "ml", "marks" : 1})
questionsY3Summer.push({ "question" : "What fraction of shape A is shaded?", "answer" : "1/7|1/4|2/7", "type": 1, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "What fraction of shape B is shaded?", "answer" : "3/8|1/4|5/8", "type": 1, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "What fraction of shape C is shaded?", "answer" : "7/10|4/10|8/10", "type": 1, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "Emile weighs a gem. He adds one more gems and his pirate hat. How much does his pirate hat weigh? ", "answer" : "340", "type": 0, "units" : "grams", "marks" : 1})
questionsY3Summer.push({ "question" : "Here is an addition pyramid. In the addition pyramid, the two numbers below add to make the number above. What is the value of A?", "answer" : "4/7|3/7|2/7", "type": 1, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "What are the values of B and C? ", "answer" : "B is 1 over 7 and C is 3 over 7|B is 1 over 7 and C is 1 over 7|B is 2 over 7 and C is 3 over 7", "type": 1, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "Here is another addition pyramid. What is the value of D?", "answer" : "300|320|600", "type": 1, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "What are the values of E and F? ", "answer" : "E is 320 and F is 170|E is 300 and F is 170|E is 320 and F is 150", "type": 1, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "Aimee is flying between two planets. The time at which she leaves and the time at which she arrives are shown below. How many minutes does it take for Aimee to travel between the planets? ", "answer" : "30", "type": 0, "units" : "minutes", "marks" : 1})
questionsY3Summer.push({ "question" : "Complete the number statement: 460 + 30 = 459 + ____", "answer" : "31", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "Complete the number statement: 460 - 30 = 459 - ____", "answer" : "29", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "Scrambler has £20. Scrambler buys three single gems and 4 bags of gems . How much does his shopping cost?", "answer" : "12.1", "type": 0, "units" : "£", "marks" : 1})
questionsY3Summer.push({ "question" : "How much change does Scrambler receive? ", "answer" : "7.9", "type": 0, "units" : "£", "marks" : 1})
questionsY3Summer.push({ "question" : "Emile is facing north. He turns <b>clockwise</b> through one right-angle. In which direction is Emile facing now? ", "answer" : "East|West|South", "type": 1, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "Aimee is facing south. She turns <b>anti-clockwise through three right-angles.In which direction is Aimee facing now? ", "answer" : "West|East|North", "type": 1, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "There are red, green and blue gems in a jar. // 1/4 of the gems are red.  // 1/4 of the gems are green. //8 gems are blue. //What fraction of the gems are blue? ", "answer" : "1/2|1/4|3/4", "type": 1, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "How many gems are in the jar in total? ", "answer" : "16", "type": 0, "units" : "gems", "marks" : 1})

  var questionsY4Summer = [];
  questionsY4Summer.push({ "question" : "Emile is counting in 9s from 0 to 90. Which numbers will she say? ", "answer" : "27 and 63|24 and 67|24 and 56", "type": 1, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "Aimee has made a number on the place value grid. What number has Aimee made? ", "answer" : "3578", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "Aimee adds some hundred counters. She has now made 3,898. How many hundred counters did Aimee add? ", "answer" : "3", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "Looking at the number line below, what number is A? ", "answer" : "0.8|1.0|1.2", "type": 1, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "Looking at the number line below, what number is B? ", "answer" : "2&3/4|2&1/2|3&1/4", "type": 1, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "Scrambler has represented a decimal number. What number has Scrambler represented?", "answer" : "0.64", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "Aimee has also represented a decimal number. What number has Aimee represented?", "answer" : "0.6", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "36 rounded to the nearest 10 is?", "answer" : "40", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "3.6 rounded to the nearest whole number is? ", "answer" : "4", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "360 rounded to the nearest 10 is? ", "answer" : "360", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "Emile flies round a spaceship 8 times. The total distance Emile flies is 40 miles. How long is a circuit around the spaceship?", "answer" : "5", "type": 0, "units" : "miles", "marks" : 1})
questionsY4Summer.push({ "question" : "Scrambler flies the same circuit 7 times. How far does Scrambler fly? ", "answer" : "35", "type": 0, "units" : "miles", "marks" : 1})
questionsY4Summer.push({ "question" : "How many purple rockets are represented on the chart?", "answer" : "11", "type": 0, "units" : "rockets", "marks" : 1})
questionsY4Summer.push({ "question" : "How many blue and green rockets are represented? ", "answer" : "25", "type": 0, "units" : "rockets", "marks" : 1})
questionsY4Summer.push({ "question" : "Is 1/2 of 18 greater than, less than or equal to 1/4 of 18?", "answer" : "Greater than|Less than|Equal to", "type": 1, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "Is 1/3 of 18 greater than, less than or equal to 2/3 of 18?", "answer" : "Less than|Greater than|Equal to", "type": 1, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "Is 1/2 of 18 greater than, less than or equal to 1/3 of 27?", "answer" : "Equal to|Less than|Greater than", "type": 1, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "What time does the clock A show?", "answer" : "00:05|12:15|21:55", "type": 1, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "What time does the clock B show?", "answer" : "16:15|03:15|17:15", "type": 1, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "A shop has the below hats for sale. Emile buys a space helmet and a pirate hat. How much do they cost? ", "answer" : "32.25", "type": 0, "units" : "£", "marks" : 1})
questionsY4Summer.push({ "question" : "Emile pays with one £20 note, one £10 note and one £5 note. How much change does he receive?", "answer" : "2.75", "type": 0, "units" : "£", "marks" : 1})
questionsY4Summer.push({ "question" : "Aimee wants an engineer helmet. She saves £3 every week. For how many weeks does Aimee need to save? ", "answer" : "5", "type": 0, "units" : "weeks", "marks" : 1})
questionsY4Summer.push({ "question" : "Which shape is symmetric about the line shown, A, B or C?", "answer" : "C|A|B", "type": 1, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "What is the area of shape B? ", "answer" : "25", "type": 0, "units" : "cm²", "marks" : 1})
questionsY4Summer.push({ "question" : "Which angle is the largest A, B or C? ", "answer" : "C|A|B", "type": 1, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "Which angle is an acute angle? ", "answer" : "A|B|C", "type": 1, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "Scrambler has plotted 3 points on a grid. What are the co-ordinates of point A?", "answer" : "(7,3)|(3,7)|(8,3)", "type": 1, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "Scrambler joins the points to make a quadrilateral. What type of quadrilateral has Scrambler drawn? ", "answer" : "Square|Parrallelogram|Rectangle", "type": 1, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "Scrambler translates the shape 3 squares to the left and 2 squares down. What are the new co-ordinates of A? ", "answer" : "(4,1)|(10,5)|(10,1)", "type": 1, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "Scrambler has collected all the gems from 9 planets. Each planet had 63 gems. How many gems has Scrambler collected? ", "answer" : "567", "type": 0, "units" : "gems", "marks" : 1})
questionsY4Summer.push({ "question" : "3 tens and 6 ones divided by 10 is what?", "answer" : "36 tenths|3 tens and 6 tenths|0.36", "type": 1, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "5 tens and 7 ones divided by 10 is what?", "answer" : "5.7|5 tens and 7 tenths|0.57", "type": 1, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "1/8 + 1/8 + 1/8 + 1/8 = ", "answer" : "0.5|0.25|0.375", "type": 1, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "1/10 + 1/10 + 1/10 = ", "answer" : "0.3|0.2|0.1", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "Emile and Aimee both earn £100 per month. Emile saves 3/5 of his money each month. Aimee saves 1/4 of her money each month. They save for 6 months. How much money does Emile have? ", "answer" : "360", "type": 0, "units" : "£", "marks" : 1})
questionsY4Summer.push({ "question" : "How much money does Aimee have? ", "answer" : "150", "type": 0, "units" : "£", "marks" : 1})
questionsY4Summer.push({ "question" : "What is the difference in the amount Emile and Aimee have saved?", "answer" : "210", "type": 0, "units" : "£", "marks" : 1})



  var questionsY5Summer = [];
  questionsY5Summer.push({ "question" : "Which numbers are multiples of 7?", "answer" : "14, 84|14,76|21, 64", "type": 1, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "Aimee has starred some numbers in a grid. All the numbers she has starred are multiples of 8. True or false? ", "answer" : "True|False", "type": 4, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "All the numbers she has starred are even. True or false? ", "answer" : "True|False", "type": 4, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "All the numbers she has starred are multiples of both 2 and 4. True or false? ", "answer" : "True|False", "type": 4, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "Aimee has 8 bags of knowledge gems. Each bag has 6 gems. How many gems does she have?", "answer" : "48", "type": 0, "units" : "gems", "marks" : 1})
questionsY5Summer.push({ "question" : "Aimee uses up half the knowledge gems. She then packs the gems evenly into 4 boxes to give to Scrambler. How many gems are in each box?", "answer" : "6", "type": 0, "units" : "gems", "marks" : 1})
questionsY5Summer.push({ "question" : "In which number does the number 7 represent 7 hundreds? ", "answer" : "86,723|157|3,673", "type": 1, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "In which number does 8 represent 8 tenths?", "answer" : "7.89|8.79|87.96", "type": 1, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "Which pair of lines are parallel? ", "answer" : "A|B|C", "type": 1, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "Emile blasts off from a planet at the time shown. It takes 25 minutes to leave the atmosphere. Which digital clock shows the time at which Emile leaves the atmosphere? ", "answer" : "C|B|A", "type": 1, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "Two shapes are shown. Are both shapes A and B hexagons? ", "answer" : "True|False", "type": 4, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "Shape A is irregular? ", "answer" : "False|True", "type": 4, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "All the angles in shape B are acute?", "answer" : "False|True", "type": 4, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "Emile has 89 gems. Scrambler has four times as many gems as Emile. How many gems do they have altogether? ", "answer" : "445", "type": 0, "units" : "gems", "marks" : 1})
questionsY5Summer.push({ "question" : "What is the value of angle A?", "answer" : "35°|65°|45°", "type": 1, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "The numbers are decreasing by the same amount each time. What number should be in place of A? ", "answer" : "56", "type": 0, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "What number should be in place of B?", "answer" : "2,234|1,234|2,334", "type": 1, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "Complete the sum below and find out what number is A?", "answer" : "0.9", "type": 0, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "Complete the sum below and find out what number is B?", "answer" : "0.81", "type": 0, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "Looking at the number line below. What is the value of A? ", "answer" : "6.8", "type": 0, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "Looking at the number line below. What is the value of B? ", "answer" : "6.89", "type": 0, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "Emile flies around a spaceship 6 times. The total distance Emile flies is 900metres. How far does Emile fly each time he flies around the spaceship?", "answer" : "150", "type": 0, "units" : "metres", "marks" : 1})
questionsY5Summer.push({ "question" : "Scrambler flies around the spaceship 5 times. How far does Scrambler fly?", "answer" : "750", "type": 0, "units" : "metres", "marks" : 1})
questionsY5Summer.push({ "question" : "An area is drawn on a centimetre square grid. What is the area of the shape? ", "answer" : "12", "type": 0, "units" : "cm²", "marks" : 1})
questionsY5Summer.push({ "question" : "Which translation will move the red rectangle to be in the same location as the blue rectangle? ", "answer" : "(6, 5)|(5, 6)|(6, 6)", "type": 1, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "Aimee has made a shape from centimetre cubes. How many cubes did she use? ", "answer" : "17", "type": 0, "units" : "cubes", "marks" : 1})
questionsY5Summer.push({ "question" : "What is 1 7/8 as an improper fraction?", "answer" : "15/8|8/8|1&14/16", "type": 1, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "What is 16/7 as a mixed number? ", "answer" : "2&2/7|1&2/7|1&6/7", "type": 1, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "Which net A, B or C matches the shape shown below? ", "answer" : "B|A|C", "type": 1, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "Emile's Roman shield is twice as tall as it is wide. One inch is approximately 2.5cm. How wide is Emile's shield? ", "answer" : "25", "type": 0, "units" : "cm", "marks" : 1})
questionsY5Summer.push({ "question" : "Scrambler has 120 gems. He uses a third of the gems on Monday. On Tuesday, he uses 25% of the remaining gems. How many gems did Scrambler use on Tuesday? ", "answer" : "20", "type": 0, "units" : "gems", "marks" : 1})


  var questionsY6Summer = [];
  questionsY6Summer.push({ "question" : "Emile has red, blue and green gems. There 72 red gems. There are 49 green gems. There are 400 gems in total. How many blue gems does Emile have? ", "answer" : "279", "type": 0, "units" : "gems", "marks" : 1})
questionsY6Summer.push({ "question" : "Which number represents two thousand and twenty-one?", "answer" : "2,021|221|20,021", "type": 1, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "Which number represents two thousand, three hundred and forty?", "answer" : "2,340|20,340|2,304", "type": 1, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "What does XXIV represent?", "answer" : "24", "type": 0, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "Aimee has 3 red gems for every green gem. Aimee has 9 red gems. How many green gems does Aimee have? ", "answer" : "3", "type": 0, "units" : "gems", "marks" : 1})
questionsY6Summer.push({ "question" : "How many gems does Aimee have in total? ", "answer" : "12 gems|36 gems|9 gems", "type": 1, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "Which clock shows the time - A, B or C?", "answer" : "C|A|B", "type": 1, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "Scrambler sets off at 16:35. His trip takes 55 minutes. At what time does Scrambler arrive? ", "answer" : "17:30|16:90|17:20", "type": 1, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "What is 20 more than 3 5/6? ", "answer" : "23&5/6|3&25/6|203&5/6", "type": 1, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "How many sixths are in 3 5/6?", "answer" : "23|25|26", "type": 1, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "Purple gems cost £6.50. Silver gems cost ten times as much. How much does a silver gem cost?", "answer" : "65", "type": 0, "units" : "£", "marks" : 1})
questionsY6Summer.push({ "question" : "How much does one purple gem and one silver gem cost?", "answer" : "71.5", "type": 0, "units" : "£", "marks" : 1})
questionsY6Summer.push({ "question" : "Below is a chart showing the temperature of a rocket's engine. What temperature is the engine at 1 o'clock? ", "answer" : "1750", "type": 0, "units" : "°", "marks" : 1})
questionsY6Summer.push({ "question" : "Emile is flying to see Aimee. Aimee lives 20 kilometres away from where Emile set off. Emile has flown 6,780 metres. How far does Emile have left to travel?", "answer" : "13220", "type": 0, "units" : "metres", "marks" : 1})
questionsY6Summer.push({ "question" : "Which triangle is a reflection of the red triangle?", "answer" : "The blue triangle. |The orange triangle.|The purple triangle.", "type": 1, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "The red triangle has been translated to the same position as the orange triangle. Which is the translation?", "answer" : "(11,0)|(9,2)|(9,0)", "type": 1, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "What percentage of the shape is shaded? ", "answer" : "30%|20%|25%", "type": 1, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "A is half way between 0.3 and 0.9. What is the value of A? ", "answer" : "0.6", "type": 0, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "What is the value of B?", "answer" : "100|75|125", "type": 1, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "What is the missing number? ", "answer" : "3", "type": 0, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "Rocket fuel is made from a mix of petrol and jet fuel. Jet fuel is 4/5 of the rocket fuel. Emile has 200ml petrol.  How much jet fuel is needed to make rocket fuel? ", "answer" : "800", "type": 0, "units" : "ml", "marks" : 1})
questionsY6Summer.push({ "question" : "The shape below is made of an equilateral triangle, a scalene triangle and a right-angled triangle. What is the size of angle a? ", "answer" : "30", "type": 0, "units" : "°", "marks" : 1})
questionsY6Summer.push({ "question" : "Aimee writes down the cost of 4 different hats: £8.00; £2.00; £4.00 & £6.00. What is the mean price of a hat? ", "answer" : "5", "type": 0, "units" : "£", "marks" : 1})
questionsY6Summer.push({ "question" : "Aimee removes one of the hats. The mean is now £4.00. Which hat did she remove? ", "answer" : "The £8.00 hat. |The £6.00 hat. |The £2.00 hat.", "type": 1, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "Calculate the volume of the cuboid. ", "answer" : "1200", "type": 0, "units" : "cm³", "marks" : 1})
questionsY6Summer.push({ "question" : "4x + 2y = 28 Find the value of y, if x=4.", "answer" : "6", "type": 0, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "Which statement is true? ", "answer" : "A|B|C", "type": 1, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "2 pirate hats and 2 Roman helmets cost £24. 2 pirate hats and 4 Roman helmets cost £32. How much does a Roman helmet cost? ", "answer" : "4", "type": 0, "units" : "£", "marks" : 1})
questionsY6Summer.push({ "question" : "How much does a pirate hat cost? ", "answer" : "8", "type": 0, "units" : "£", "marks" : 1})
questionsY6Summer.push({ "question" : "Scrambler is trying to make 10 litres of a new type of rocket fuel made from just petrol and jet fuel. 2/5 of the rocket fuel is petrol. He has 7&2/3 litres of jet fuel. How many litres of petrol does Scrambler need?", "answer" : "4", "type": 0, "units" : "litres", "marks" : 1})
questionsY6Summer.push({ "question" : "How many litres of jet fuel does Scrambler need? ", "answer" : "6", "type": 0, "units" : "litres", "marks" : 1})
questionsY6Summer.push({ "question" : "How many litres of jet fuel does Scrambler have left? ", "answer" : "1&2/3", "type": 3, "units" : "litres", "marks" : 1})

  

//above is questions section
  
  const [questions, setQuestions] = useState([]);
  console.log(props);

  var timer = -1;

  //SET TIMER BASED ON THESE
  if (status == false){
    currQuestion = [];
    questionNum = 0;
    useranswers = [];
    shuffledAnswers = [];
    //check what questions it is, checking year first will check terms later like summer etc
    if (props.assessment_type[0] == "1"){
      timer = -1;
      setQuestions(questionsY1Summer);
    } else if (props.assessment_type[0] == "2"){
      timer = -1;
      setQuestions(questionsY2Summer);
    } else if (props.assessment_type[0] == "3"){
      timer = 2100;
      setQuestions(questionsY3Summer);
    } else if (props.assessment_type[0] == "4"){
      timer = 3000;
      setQuestions(questionsY4Summer);
    } else if (props.assessment_type[0] == "5"){
      timer = 3000;
      setQuestions(questionsY5Summer);
    } else if (props.assessment_type[0] == "6"){
      timer = 3000;
      setQuestions(questionsY6Summer);
    }
    setStatus(true);
  }
  console.log(questions);

  if (useranswers.length == 0 && questions.length > 0){
    for (let i = 0; i < questions.length; i++) {
      useranswers.push("");
      shuffledAnswers.push("");
      //DO SHUFFLE QUESTIONS
      if (questions[i].type == 1){
        let choices = questions[i].answer.split("|");
        choices = shuffleArray(choices);
        console.log("CHOICES");
        console.log(choices);
        shuffledAnswers[i] = choices;
      }
    }
    console.log("initial Answers array:")
    console.log(useranswers);
  }

  /*
  var timer = -1;
  if(props.timelimit > 0)
  {
      timer = props.timelimit;
  }
  else
  {
      timer = 999;
  }*/

  var questionMax = -1;
  if(props.minimum > 0)
  {
      questionMax = props.minimum;
  }

  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

  console.log("question number: " + questionNum);

  /*TODO: 
  only submit at the end
  may need to scrap a lot of the core code and do it from the ground up
  create a new calculator class just for assessments
  the background image method needs to set it equal to currentquestion number

  */

  //Sets the question to a new one, currently no check for being the same question
  function newQuestion() {
    //questionNum++;
    currQuestion = questions[questionNum];
    console.log("Current question");
    console.log(currQuestion);
    console.log("Answers so far:");
    console.log(useranswers);
    setCurrentQuestion(currQuestion);
    setRefresh(!refresh);
    //CheckImage();
  }


  //Called on click
  async function checkResult(value, callback) {
    var isCorrect = true;
    if (value) {
      console.log(value.value + " " + currQuestion.correct);
      //correct answer
      if (currQuestion.correct === value.value) {
        setCorrectQuestions([...correctQuestions, currQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }

        newQuestion();
      }
      //incorrect answer
      else {
        isCorrect = false;
        setIncorrectQuestions([...incorrectQuestions, currQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
        };

        setFeedback([...feedback, result]);
        setColouredFeedback(true);
        setWaitTime(2);
      }
      //Generates a new question
      //newQuestion();

    }
  }

  function MultipleButtons() {
    console.log(currentQuestion);
    return "blank"
    

  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else {

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);

  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      console.log(questions);
      var sample = questions[questionNum];
      currQuestion = sample;
      setCurrentQuestion(currQuestion);
      //CheckImage();
    }
  }, [questions]);

  //No clue
  useEffect(() => {
    if (status !== undefined && status == true) {
      setLoading(false);
    }
  }, [status]);


  function QuestionImage() {
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length){
      return blankbg;
    }
    let requireString = "Year"+props.assessment_type[0];
    if (props.assessment_type[3] == "ar"){
      requireString+= "/ARSummerEnd";
    }else if (props.assessment_type[3] == "re"){
      requireString+= "/RESummerEnd";
    }
    requireString += "/year"+props.assessment_type[0]+"question"+(questionNum+1)+".png";
    return (require("../../assets/maths_assessments/assets/"+requireString))
}

async function setAnswer(value)
  {
    console.log("SET VALUE");
    console.log(value);
    useranswers[questionNum] = value;
    console.log(useranswers);
  }

  function NavigationButtons(){
    if (questionNum != 0 && questionNum != questions.length){
      return (
        <div>
        <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>
        <NavigationButton
        onClick={() => nextQuestion()}>
          <NavigationText>
            Next
          </NavigationText>
        </NavigationButton>
        </div>
      );
    }else if (questionNum < questions.length){
      return (
      <div>
      <NavigationButton
      onClick={() => nextQuestion()}>
        <NavigationText>
          Next
        </NavigationText>
        
      </NavigationButton>
      </div>
      );
    }
    else{
      return (
        <div>
         <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>

        <Button onClick={() => GameOver()} style={{fontSize: "3em", height: "100px", width: "300px", position: "relative", right: "-45%", textAlign: "center", lineHeight: "3.2"}}>
          Submit
        </Button>
        </div>
        );
    }
  }

  function GameOver(){
    setGameOver(true);//go to endscreen
  }

  function CompareIfCorrect(youranswer, question){
    if (question.type != 1){
      if (question.answer == youranswer){
        return true;
      }else{
        return false;
      }
    }else{
      let correct = question.answer.split("|")[0];
      if (youranswer == correct){
        return true;
      }else{
        return false;
      }
    }
  }

  //I moved this to be called from the practicegameassessment script so it is done on timeout and ending game
  async function SubmitAssessment(){
     let correct = 0;      
    let questionsAnswered = [];
    for (let i = 0; i < questions.length; i++) {
        if (CompareIfCorrect(useranswers[i], questions[i])){
          let data = {
            question: questions[i].question,
            correct: true,
            answer: useranswers[i]
        };
        correct++;
        questionsAnswered.push(data);
        }else{
          let data = {
            question: questions[i].question,
            correct: false,
            answer: useranswers[i]
        };
        questionsAnswered.push(data);
        }
      console.log(JSON.stringify(questionsAnswered));
    }

    let topicstats = [];
    let temptih = {
      topic_key : "mathsassessmentsub",
      game_key : "basic_mathments",
      num_asked : questionsAnswered.length,
      num_correct : correct,
      average_ans_time : "0.0"
    }
    topicstats.push(temptih);

    axios({
        url: `${process.env.REACT_APP_API}/submissions`,
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authState.access_token}`
        },
        data: {
            "homework_id": props.homework.id,
            "topicstats": topicstats,
            "custom": null,
            "platform": "Assessment|" + "WEB" + "|" + process.env.REACT_APP_VERSION_NO,
            "game_id": props.homework.galaxy_id,
            "questionsAnswered": JSON.stringify(questionsAnswered)
        }
      }).then((response) => {
        setGameOver(true);//go to endscreen
      })
  }

  function SubmitTimeout(){
    SubmitAssessment();
  }

  
  async function nextQuestion(value)
  {
    questionNum++;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
    //setClear(true);
  }

  function ResetClear(){
    setClear(false);
  }

  async function previousQuestion(value)
  {
    questionNum--;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
  }

  //this returns a table that ticks what questions are done
   function GetEndTable(){
    var html = "";
    html+= "<div>"
    //create a table where it equals amount of questions
    html+= '<table style="margin-top: 20%; width:100%; border-collapse: collapse;">'
    html+= '<tr>'

    for (let i = 0; i < questions.length; i++) {
      console.log(i);
      html+= '<td style="height: 100px, text-align:center; font-size: 4em;">'
      html+= 'Q'+(i+1);
      html+= '</td>';
    }
    html+='</tr><tr>';
    
    useranswers.forEach(element => {
      if (element == ""){
        html+= '<td style="height: 100px; border: 1px solid #9999;"> </td>'
      }else{
        html+= '<td style="height: 100px; background: #FFA500; border: 1px solid #9999;"> </td>'
      }
    });
    html+= "</tr>";
    html+="</table>";
    html+= "</div>";

    return html;
  }

  //if the user presses a multichoice button
  function PressMulti(value) {
    useranswers[questionNum] = value;
    setRefresh(!refresh);
  }

  function MultichoiceButtons(){
    let choices = shuffledAnswers[questionNum];
    console.log(shuffledAnswers);
    console.log(choices);

    return (
    <div>
       {choices.map(answer => {
        if(useranswers[questionNum] == "" || answer != useranswers[questionNum]){
          return (
            <MButton
            {...console.log(answer)}
            value={<div dangerouslySetInnerHTML={answer} />}
            style={{ flex: 1, margin: "20px" }}
            onClick={() => PressMulti(answer)}
          >
              <div style={{ height: "80%", width: "100%" }}>
              <Textfit mode="multi" max="99" style={{ textShadow: "2px 2px 4px #000000", position: "relative", top: "24%", height: "90%" }}>
                  {answer}
                </Textfit>
              </div>
          </MButton>
         )}
        return (
          <MButtonSelected
          {...console.log("SELECTED")}
          value={<div dangerouslySetInnerHTML={answer} />}
          style={{ flex: 1, margin: "20px" }}
          onClick={() => PressMulti(answer)}
        >
            <div style={{ height: "80%", width: "100%" }}>
              <Textfit mode="multi" max="99" style={{ textShadow: "2px 2px 4px #000000", position: "relative", top: "24%", height: "90%" }}>
                {answer}
              </Textfit>
            </div>
        </MButtonSelected>
        )
      })}
    </div>
    )
  }

  function ShowMarks(){
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length){
      return "";
    }else{
      return marks1;
    }
  }

  //I don't know how to comment html/CSS
  return (
    <>
      <PracticeGame
        parent={props}
        gameOver={gameOver}
        SubmitMethod={() => SubmitTimeout()}
        correct={correctQuestions}
        incorrect={incorrectQuestions}
        score={score}
        defaultTimer={timer}
        questionNum={questionNum}
        questionNumMax ={questions.length}
        questionLimit={questionMax}
        onBack={() => props.onBack()}
        loading={loading}
        feedback={feedback}
        questionFontSize="0.7em"
        restart={() => {
          setCombo(0);
          setScore(0);
          setCorrectQuestions([]);
          setIncorrectQuestions([]);
        }}
      >
        <div id="extrascaling">
        <div style={{ backgroundImage: `url(${ShowMarks()}), url(${QuestionImage()})`, position: "relative", top: "-10%", height: "1400px", backgroundSize: "cover" }} >
            <Body>
              
              <div style={{ width: "80%" }}>
                {currQuestion != undefined ? (


                  <Container update={refresh}>

                    <div style={{ display: "flex", flexDirection: "row", alignSelf: "flex-end" }}>
                        <div style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between"
                        }}>
                          {currQuestion.type == 0 &&
                            <AsCalculator
                            onChange={setAnswer}
                            fakeprop={true}
                            resetclear = {ResetClear}
                            currentQuestion={currQuestion}
                            currentAnswer={useranswers[questionNum]}
                            //ref={this.calculator}
                            />
                          }
                          {currQuestion.type == 1 &&
                            <MultiChoiceContainer>
                            {MultichoiceButtons()}
                            </MultiChoiceContainer>
                            }
                {currQuestion.type == 2 &&
                 <AsCalculatorFraction
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }
                 {currQuestion.type == 3 &&
                 <AsCalculatorFractionMixed
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }    
                        </div>
                    </div>
                    <NavigationContainer>
                    {NavigationButtons()}
                    </NavigationContainer>

                  </Container>

                ) : <div>
                  <div dangerouslySetInnerHTML={{ __html: GetEndTable() }}>
                </div><NavigationContainer>{NavigationButtons()}</NavigationContainer></div> }
              </div>
            </Body>
        </div>
        </div>
      </PracticeGame>
    </>
  );
}

const MultiChoiceContainer = styled.div`
  position: relative;
  top: 50%;
  right: 20%;
`

const NavigationContainer = styled.div`
  position: fixed;
  top: 70%;
  right: 50%;
`

const Body = styled.div`
        width: 100%;
        height: 100%;
  background-image: url("");
        background-size: cover;
        background-position: 0px -1px;
        display: flex;
        justify-content: center;
        padding-top: 100px;
      `;

const Result = styled.div`
        width: 100%;
        height: 100%;
        font-size: 5em;
        text-align: center;
        border: solid 2px #683d8c;
      `;

const Combo = styled.div`
        background: #4391bb;
        width: 120px;
        height: 120px;
        border-radius: 75px;
        border: solid #204b7b 4px;
        display: flex;
        flex-direction: column;
        text-align: center;
        color: #fff;
        justify-content: center;
        font-weight: 600;
        margin-left: 50px;
      `;

const Marks = styled.div`
      font-size: 4em;
      position: relative;
      right: 33%;
      top: 73%;
    `;

const Container = styled.div`
      width:100%%;
      height:95%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;

const Question = styled.div`
      background: #FFF;
      user-select: none;
      width: 90%;
      height: 120px;
      line-height: 90px;
      font-size: 4em;
      margin: 15px 25px;
      text-align: center;
      font-weight: 600;
      border: none;
      border-radius: 10px;
    `;

const Button = styled.div`
    text-align: center;
    width: 20%;
    height: 150px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: rgb(234, 146, 19);
    background: linear-gradient(
      0deg,
      rgba(234, 146, 19, 1) 0%,
      rgba(255, 186, 32, 1) 100%
    );
    border: 2px solid #e88f12;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

  const MButton = styled.div`
    text-align: center;
    width: 350px;
    height: 150px;
    margin: 5px;
    color: #fff;

    background: linear-gradient(
      0deg,
      rgba(200, 200, 200, 1) 0%,
      rgba(225, 225, 225, 1) 100%
    );
    border: 2px solid #fff;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
    user-select: none; /* supported by Chrome and Opera */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
  `;

  const MButtonSelected = styled.div`
  text-align: center;
  width: 350px;
  height: 150px;
  margin: 5px;
  color: #fff;
  background: linear-gradient(
    0deg,
    rgba(200, 200, 120, 1) 0%,
    rgba(225, 225, 100, 1) 100%
  );
  border: 2px solid #fff;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
`;

const NavigationButton = styled.div`
text-align: center;
width: 118px;
height: 144px;
margin: 5px;
position: absolute;
right: -1000px;
top: 150px
background-image: url(${next});
color: #000;
user-select: none;
box-sizing: border-box;
border-radius: 0.25em;
cursor: pointer;
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  margin-bottom: 0;
}
`;

const NavigationButtonBack = styled.div`
text-align: center;
width: 118px;
height: 144px;
margin: 5px;
position: absolute;
top: 150px;
right: 1000px
background-image: url(${back});
color: #000;
box-sizing: border-box;
border-radius: 0.25em;
cursor: pointer;
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  margin-bottom: 0;
}
`;

  const NavigationText = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 40%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}
  `;

  const NavigationTextBack = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 60%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  `;

const ButtonImage = styled.img`
max-width: 80%;
max-height: 80%;
padding-top: 15px;
`